{% block jga_revocation_lookup_fields %}
    <div class="jga-revocation-lookup-fields">
        <div v-if="items.length === 0" class="jga-revocation-lookup-fields__empty">
            {{ $tc('jga-revocation.lookupFields.empty') }}
        </div>

        <table v-else class="jga-revocation-lookup-fields__table">
            <thead>
                <tr>
                    <th>{{ $tc('jga-revocation.lookupFields.colField') }}</th>
                    <th>{{ $tc('jga-revocation.lookupFields.colTechnicalName') }}</th>
                    <th class="jga-revocation-lookup-fields__col-flag">{{ $tc('jga-revocation.lookupFields.colActive') }}</th>
                    <th class="jga-revocation-lookup-fields__col-actions"></th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(item, index) in items" :key="item.id" :class="{ 'is-inactive': !item.active, 'is-missing': isMissing(item) }">
                    <td>{{ labelForItem(item) }}</td>
                    <td class="jga-revocation-lookup-fields__technical">{{ technicalNameForItem(item) }}</td>
                    <td class="jga-revocation-lookup-fields__col-flag">
                        <sw-switch-field
                            :value="item.active"
                            @change="setActive(index, $event)"
                            @update:value="setActive(index, $event)"
                        ></sw-switch-field>
                    </td>
                    <td class="jga-revocation-lookup-fields__col-actions">
                        <button
                            type="button"
                            class="jga-revocation-lookup-fields__action-btn"
                            :title="$tc('jga-revocation.lookupFields.modalTitle')"
                            @click="editItem(index)"
                        >
                            <sw-icon name="regular-pencil-s" small></sw-icon>
                        </button>
                        <button
                            type="button"
                            class="jga-revocation-lookup-fields__action-btn jga-revocation-lookup-fields__action-btn--danger"
                            :title="$tc('jga-revocation.lookupFields.delete')"
                            @click="askDelete(index)"
                        >
                            <sw-icon name="regular-trash" small></sw-icon>
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>

        <div class="jga-revocation-lookup-fields__add">
            <sw-button variant="ghost" @click="addItem">
                <sw-icon name="regular-plus-circle" small></sw-icon>
                {{ $tc('jga-revocation.lookupFields.addEntry') }}
            </sw-button>
        </div>

        <sw-modal
            v-if="editingItem"
            :title="$tc('jga-revocation.lookupFields.modalTitle')"
            variant="default"
            @modal-close="cancelEdit"
        >
            <div class="jga-revocation-lookup-fields__modal">
                <sw-entity-single-select
                    :value="editingItem.customFieldId"
                    entity="custom_field"
                    :criteria="customFieldCriteria"
                    :label="$tc('jga-revocation.lookupFields.labelCustomField')"
                    :help-text="$tc('jga-revocation.lookupFields.helpCustomField')"
                    label-property="name"
                    @update:value="onCustomFieldChange"
                >
                    <template #result-label-property="{ item }">
                        <div class="jga-revocation-lookup-fields__option">
                            <strong>{{ pickLabel(item) }}</strong>
                            <span class="jga-revocation-lookup-fields__option-name">{{ item.name }}</span>
                        </div>
                    </template>
                    <template #selection-label-property="{ item }">
                        {{ pickLabel(item) }}
                    </template>
                </sw-entity-single-select>

                <sw-switch-field
                    v-model:value="editingItem.active"
                    :label="$tc('jga-revocation.lookupFields.flagActive')"
                ></sw-switch-field>

                <div v-if="isDuplicate" class="jga-revocation-lookup-fields__duplicate-error">
                    {{ $tc('jga-revocation.lookupFields.duplicateError') }}
                </div>
            </div>

            <template #modal-footer>
                <sw-button variant="ghost" @click="cancelEdit">
                    {{ $tc('jga-revocation.lookupFields.cancel') }}
                </sw-button>
                <sw-button
                    variant="primary"
                    :disabled="!editingItem.customFieldId || isDuplicate"
                    @click="saveEdit"
                >
                    {{ $tc('jga-revocation.lookupFields.save') }}
                </sw-button>
            </template>
        </sw-modal>

        <sw-modal
            v-if="confirmDeleteIndex !== null"
            :title="$tc('jga-revocation.lookupFields.deleteTitle')"
            variant="small"
            @modal-close="cancelDelete"
        >
            <p>{{ $tc('jga-revocation.lookupFields.deleteConfirmation') }}</p>
            <template #modal-footer>
                <sw-button variant="ghost" @click="cancelDelete">
                    {{ $tc('jga-revocation.lookupFields.cancel') }}
                </sw-button>
                <sw-button variant="danger" @click="confirmDelete">
                    {{ $tc('jga-revocation.lookupFields.delete') }}
                </sw-button>
            </template>
        </sw-modal>
    </div>
{% endblock %}
